import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { Stock } from '../restaurant-manager.models';

@Injectable({
    providedIn: 'root'
})
export class StockService {

    constructor(private apiService: ApiService) { }

    update(data: any): Observable<any> {
        return this.apiService.put<any>('/stocks/batch-update', data, true);
    }

}
